import React from 'react';
import PageHeader from '../../../../components/common/PageHeader';

import { LB_PERFORMANCE_MODULE } from '../../../../utils/constant/labels';

const { LB_PERFORMANCE_HEADER_TITLE } = LB_PERFORMANCE_MODULE;

const PerformanceTools = () => {
  return (
    <PageHeader
      headerTitle={LB_PERFORMANCE_HEADER_TITLE}
      // renderRight={() => {
      //   return (
      //     <div className="col-auto d-flex w-sm-100">
      //       <button
      //         className="btn btn-dark btn-set-task w-sm-100"
      //         onClick={() => {
      //           setState({
      //             ...state,
      //             selectGender: [],
      //             selectDepartMentData: [],
      //             selectMaritalStatus: [],
      //             selectDesignationData: [],
      //             selectEmployeeData: [],
      //             isModal: { model: true, submit: false },
      //             editLeaveTypeData: {},
      //             modalHeader: {
      //               title: LB_PERFORMANCE_TITLE,
      //               isEdit: false,
      //               editId: ''
      //             }
      //           });
      //           // reset();
      //         }}
      //       >
      //         <i className="icofont-plus-circle me-2 fs-6"></i>
      //         {BTN_ADD_NEW_KPI}
      //       </button>
      //     </div>
      //   );
      // }}
    />
  );
};

export default PerformanceTools;
